'use client';
import React from 'react';

import { useQuery } from '@tanstack/react-query';
import { useParams } from 'next/navigation';
import dynamic from 'next/dynamic';

import { useDevice } from '@contexts/device';
import { callService } from '@api/remote-call';
import { Separator } from '@components/formStyles';
import Breadcrumb from '@components/Breadcrumb/Breadcrumb';
import Campaign from '@components/cards/Campaign/Campaign';

import { StyledLayout, Wrapper } from './styled';

const ErrorPage404 = dynamic(() => import('../error/ErrorPage404'));
const PaymentOptionsSkeleton = dynamic(
  () => import('./PaymentOptionsSkeleton')
);
const Title = dynamic(() => import('./DesktopPaymentOptions'));
const TitleMobile = dynamic(() => import('./MobilePaymentOptions'));
const breadcrumbItems = [
  {
    title: 'Anasayfa',
    url: '/',
  },
  {
    title: 'Ödeme Seçenekleri',
    url: '/odeme-secenekleri',
  },
];

const PaymentOptions = () => {
  const params = useParams();

  //============================
  // Fetch the payment options
  //============================
  const {
    data: options,
    isInitialLoading: isLoading,
    isError,
  } = useQuery(
    ['paymentOptions'],
    () =>
      callService(
        { service: 'ContentsService', method: 'getPayments', version: 'v3' },
        {
          slug: params?.slug as string,
        }
      ),
    { enabled: Boolean(params?.slug) }
  );
  const { isDesktop } = useDevice();
  if (isError) return <ErrorPage404 />;

  return (
    <div>
      {isLoading ? (
        <PaymentOptionsSkeleton />
      ) : (
        <StyledLayout>
          <Breadcrumb items={breadcrumbItems} />
          {isDesktop ? (
            <Title title={options?.title} />
          ) : (
            <TitleMobile title={options?.title} />
          )}

          <Wrapper>
            {options?.items?.map((option) => (
              <Campaign key={option.id} {...option} />
            ))}
          </Wrapper>
          <Separator />
        </StyledLayout>
      )}
    </div>
  );
};

export default PaymentOptions;
